var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFtps(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 216,
    height: 83,
    viewBox: "0 0 216 83",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79.192 18c-.01.114-.008.23.006.348l7.331 60.387c.22 1.803 1.842 3.086 3.625 2.864l47.618-5.913c1.783-.222 3.05-1.863 2.832-3.666l-.367-3.02H145a4 4 0 0 0 4-4V14.617a4 4 0 0 0-1.172-2.829L138.04 2h68.906c5 0 9.054 3.582 9.054 8s-4.054 8-9.054 8H155.21c5 0 9.053 3.582 9.053 8s-4.053 8-9.053 8h28.455c5 0 9.054 3.582 9.054 8s-4.054 8-9.054 8h-13.16c-6.304 0-11.415 3.582-11.415 8 0 2.946 2.587 5.612 7.76 8 5 0 9.054 3.582 9.054 8s-4.053 8-9.054 8H59.497c-5 0-9.054-3.582-9.054-8s4.054-8 9.054-8H9.054C4.054 66 0 62.418 0 58s4.054-8 9.054-8H60.79c5 0 9.054-3.582 9.054-8s-4.053-8-9.054-8H28.455c-5 0-9.054-3.582-9.054-8s4.054-8 9.054-8h50.737Zm.005-.048c-4.532-.437-8.06-3.83-8.06-7.952 0-4.418 4.054-8 9.055-8h14.343A3.982 3.982 0 0 0 94 4v10.988l-13.369 1.525-.017.002a1.636 1.636 0 0 0-1.417 1.437ZM206.947 50c-5.001 0-9.055-3.582-9.055-8s4.054-8 9.054-8S216 37.582 216 42s-4.054 8-9.054 8ZM87.775 15.702l3.73-.423-3.73.423Z",
    fillOpacity: 0.3,
    fill: "#7F7F7F"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#6A6666",
    strokeWidth: 2.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "m140.15 68.278.454 3.742c.219 1.803-1.05 3.444-2.832 3.666l-47.618 5.913c-1.783.222-3.406-1.06-3.625-2.864L79.2 18.348a1.641 1.641 0 0 1 1.415-1.833l.017-.002 13.512-1.541m-6.367.73 3.73-.423",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98 1.25A2.75 2.75 0 0 0 95.25 4v61A2.75 2.75 0 0 0 98 67.75h47a2.75 2.75 0 0 0 2.75-2.75V14.617c0-.73-.29-1.429-.805-1.945L136.328 2.055a2.75 2.75 0 0 0-1.944-.805H98Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.997 2.199v9.534a2.46 2.46 0 0 0 2.456 2.466h9.544M103.997 13.683h20.811-20.81Zm0 9.545h35-35Zm0 10.5h35-35Zm0 10.5h35-35Zm0 10.5h20.811-20.81Z",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFtps);
export default __webpack_public_path__ + "static/media/ftps.d9dc95b556f7e2045b4aa493b8bfc6ae.svg";
export { ForwardRef as ReactComponent };